import React from 'react';

function SectionHeading({ title, className = "" }) {
  return (
    <div className={`border-start border-4 border-success ps-3 mb-4 ${className}`}>
      <h2 className="h5 text-success fw-semibold m-0">{title}</h2>
    </div>
  );
}

export default SectionHeading;
